import { render, staticRenderFns } from "./item-icon.vue?vue&type=template&id=f55cfca6&scoped=true"
import script from "./item-icon.vue?vue&type=script&lang=js"
export * from "./item-icon.vue?vue&type=script&lang=js"
import style0 from "./item-icon.vue?vue&type=style&index=0&id=f55cfca6&prod&lang=less"
import style1 from "./item-icon.vue?vue&type=style&index=1&id=f55cfca6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55cfca6",
  null
  
)

export default component.exports